import ImageLink from './ImageLink'

export * from './ImageLink'

export default ImageLink
